import {DateField} from 'react-admin';

const DateFieldMod = props => {
    return (<DateField {...props} emptyText={'-'} />);
};

export default DateFieldMod;